import { render } from "./CourseSharePage.vue?vue&type=template&id=70121bde&scoped=true"
import script from "./CourseSharePage.vue?vue&type=script&lang=js"
export * from "./CourseSharePage.vue?vue&type=script&lang=js"

import "./CourseSharePage.vue?vue&type=style&index=0&id=70121bde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70121bde"]])

export default __exports__